import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardActions, Typography, CardActionArea, CardMedia, Button } from '@material-ui/core';


const useStyles = makeStyles({
  card: {
    maxWidth: '100%',
  },
  fade: {
    position: 'absolute',
    bottom: 0,
    display: 'block',
    width: '100%',
    height: 50,
    backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.0), rgba(255, 255, 255, 0.9) 60%)'
  }
});

const Publication = props => {
  var { publication } = props;
  const classes = useStyles()
  return (
    <Card className={classes.card}>
      <CardActionArea href={publication.url}>
        <CardMedia
          component="img"
          alt={publication.alt}
          height="140"
          image={publication.imageUrl}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {publication.title}
          </Typography>
          <Typography variant="body2" style={{ height: '17vh', overflowY: 'hidden' }} color="textSecondary" component="p">
            {publication.description}
            <span className={classes.fade}></span>
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" color="primary" href={publication.url}>
          Learn More
        </Button>
      </CardActions>
    </Card>
  );
};

Publication.propTypes = {
  publication: PropTypes.object.isRequired
};

export default Publication;